import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";
import { useContext } from "react"
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from "../../services/api";
import CustomToolbar from '../../components/grid/CustomToolbar'
import SL_Button from '../../components/buttons/Button'
import holiday_grid_columns from "./grid_columns/holiday_grid_columns";
import { useNavigate } from "react-router-dom";
import HolidayFilters from './HolidayFilters'
import { displayMessage } from "../../services/helper";
import { PlusOutlined, DeleteOutlined, FileSearchOutlined } from '@ant-design/icons'
import { DatePicker, Form, Input, Modal, Popconfirm, Switch } from "antd";
import moment from "moment";



export default function ListHoliday() {

    const {setShowLoading, user, enums, windowHeight, mobile_mode} = useContext(GeneralContext)

    const gridRef = useGridApiRef()
    const DataGridProHeight = windowHeight * 0.7

    const [holidays, setHolidays] = useState([])
    const [currentHoliday, setCurrentHoliday] = useState(null)
    const [haveSomethingSelected, setHaveSomethingSelected] = useState(false)
    const [isModalCreateHolidayVisible, setIsModalCreateHolidayVisible] = useState(false)
    const [isModalUpdateHolidayVisible, setIsModalUpdateHolidayVisible] = useState(false)


    const navigate = useNavigate();

    useEffect(() => {
        loadHolidays()
        checkUserType()
    }, [])


    const loadHolidays = async (currentFilters) => {
        try {
            setShowLoading(true)
            const payload = { ...currentFilters }
            const rs = await api.holiday.listHolidays(payload)
            gridRef.current.setSelectionModel([])
            setHolidays(rs.data)
        } finally {
            setShowLoading(false)
        }
    }

    const checkUserType = () => {
        if (enums) {
            user.user_type != enums?.EUserTypes?.ADMIN?.code && navigate("/")
        }
    }


    const handleRowChange = (e) => {
        setCurrentHoliday(e?.row)
    }

    const renderCustomToolBar = () => {
        return (<CustomToolbar />)
    }

    const handleOnOpenModalDetailHoliday = () => {
        setIsModalUpdateHolidayVisible(true)
    }


    const handleOnOpenModalCreateHoliday = () => {
        setIsModalCreateHolidayVisible(true)
    }


    const handleOnDelete = async (data) => {
        try {
            setShowLoading(true)
            const rs = await api.holiday.delete(data.id)
            loadHolidays()
        } finally {
            setShowLoading(false)
        }
    }

    const handleWhatIsSelectedInGrid = () => {
        const _controls = []
        gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
        if (_controls.length > 0) {
            setHaveSomethingSelected(true)
        }
        else {
            setHaveSomethingSelected(false)
        }
    }

    /*Actions */
    const actionCancel = {
        field: 'cancel_action',
        headerName: displayMessage('CANCEL'),
        width: 100,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div>
                    <Popconfirm
                        zIndex={10001}
                        placement="bottomLeft"
                        title={displayMessage('WARNING_DELETE_HOLIDAYS')}
                        onConfirm={() => handleOnDelete(params.row)}
                        okText={displayMessage('YES')}
                        cancelText={displayMessage('NO')}
                        disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
                    >
                        <SL_Button
                            style={{ background: 'red', borderColor: 'pink', color: 'pink', fontWeight: 'bold' }}
                            shape="circle"
                            icon={<DeleteOutlined />}
                            disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
                        >
                        </SL_Button>
                    </Popconfirm>

                </div>
            )
        },
        disableColumnSelector: true
    }

    /* Modals */

    const CreateHoliday = props => {
        const [form] = Form.useForm()

        const createNewHoliday = payload => {
            setShowLoading(true)

            api.holiday.createNew(payload).then(
                rs => {
                    setShowLoading(false)
                    alert(displayMessage('CREATE_HOLIDAY_SUCCESS'), 'success')
                    loadHolidays()
                    setIsModalCreateHolidayVisible(false)
                }
            )
        }
        return (
            <Modal
                title={<div className="text-xl font-bold text-appian-blue">{displayMessage('CREATA_HOLIDAY_TITLE')} </div>}
                visible={isModalCreateHolidayVisible}
                onCancel={() => setIsModalCreateHolidayVisible(false)}
                centered={true}
                footer={[]}
                width={750}
                style={{ position: 'relative' }}
                bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
            >
                <Form
                    form={form}
                    className='w-full flex flex-col gap-2 p-5'
                    onFinish={createNewHoliday}
                    layout="vertical"
                    requiredMark='optional'
                >
                    <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 5, alignItems: 'center' }}>
                        <Form.Item
                            label={displayMessage('DESCRIPTION')}
                            name="description"
                            className={`w-full flex`}
                            style={{ flex: 1 }}
                            rules={[
                                { required: true },
                            ]}
                        >
                            <Input
                                type="description"
                                size='large'
                                placeholder={displayMessage('ENTER_DESCRIPTION')}
                            />
                        </Form.Item>

                        <Form.Item
                            label={displayMessage("HOLIDAYS_DATE")}
                            name="holiday_date"
                            className={`w-full flex`}
                            style={{ display: 'flex', flex: 1, maxWidth: 200, marginLeft: mobile_mode ? '' : 10, justifyContent: mobile_mode ? '' : 'flex-end' }}
                            rules={[
                                { required: true },
                            ]}
                        >
                            <DatePicker style={{ display: 'flex', flex: 1 }} size='large' />
                        </Form.Item>
                    </div>

                    <SL_Button
                        type="primary"
                        size='large'
                        htmlType="submit"
                        className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                    >
                        {displayMessage('CREATE_HOLIDAY')}
                    </SL_Button>

                </Form>
            </Modal>
        )
    }


    const EditHoliday = props => {
        const [form] = Form.useForm()
        const [myHoliday, setMyHoliday] = useState(null)
        const [edit_mode, setEditMode] = useState(false)

        function loadMyHoliday() {
            setShowLoading(true)

            api.holiday.find(currentHoliday.id)
                .then(
                    rs => {
                        rs.data.holiday_date = moment(rs.data.holiday_date)
                        setMyHoliday(rs.data)
                        form.setFieldsValue(rs.data)
                    }
                )
                .finally(
                    setShowLoading(false)
                )
        }

        useEffect(() => {
            loadMyHoliday()
        }, [])

        const updateNewHoliday = payload => {
            setShowLoading(true)
            api.holiday.update(currentHoliday.id, payload).then(
                rs => {
                    setShowLoading(false)
                    alert(displayMessage('DEATAIL_HOLIDAY_TITLE'), 'success')
                    loadHolidays()
                    setIsModalUpdateHolidayVisible(false)
                }
            )
        }

        const handleSetEditMode = () => {
            setEditMode(!edit_mode)
        }
        return (
            <Modal
                title={<div className="text-xl font-bold text-appian-blue">{displayMessage('DEATAIL_HOLIDAY_TITLE')} </div>}
                visible={isModalUpdateHolidayVisible}
                onCancel={() => setIsModalUpdateHolidayVisible(false)}
                centered={true}
                footer={[]}
                width={750}
                style={{ position: 'relative' }}
                bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
            >
                <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Switch
                        onChange={handleSetEditMode}
                        style={{ height: 30, width: mobile_mode ? '100%' : null, maxWidth: 180, marginTop: mobile_mode ? 10 : 0 }}
                        unCheckedChildren={displayMessage('EDIT_HOLIDAY')}
                        checkedChildren={displayMessage('CANCEL')}
                        disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
                    />
                </div>
                <Form
                    form={form}
                    className='w-full flex flex-col gap-2 p-5'
                    onFinish={updateNewHoliday}
                    layout="vertical"
                    requiredMark='optional'
                >
                    <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 5, alignItems: 'center' }}>
                        <Form.Item
                            label={displayMessage('DESCRIPTION')}
                            name="description"
                            className={`w-full flex`}
                            style={{ flex: 1 }}
                            rules={[
                                { required: true },
                            ]}
                        >
                            <Input
                                type="description"
                                size='large'
                                placeholder={displayMessage('ENTER_DESCRIPTION')}
                                disabled={!edit_mode}
                            />
                        </Form.Item>

                        <Form.Item
                            label={displayMessage("HOLIDAYS_DATE")}
                            name="holiday_date"
                            className={`w-full flex`}
                            style={{ display: 'flex', flex: 1, maxWidth: 200, marginLeft: mobile_mode ? '' : 10, justifyContent: mobile_mode ? '' : 'flex-end' }}
                            rules={[
                                { required: true },
                            ]}
                        >
                            <DatePicker
                                style={{ display: 'flex', flex: 1 }}
                                size='large'
                                disabled={!edit_mode}
                            />
                        </Form.Item>
                    </div>
                    <SL_Button
                        type="primary"
                        size='large'
                        htmlType="submit"
                        className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                        disabled={!edit_mode}
                    >
                        {displayMessage('UPDATE_HOLIDAY')}
                    </SL_Button>

                </Form>
            </Modal>
        )
    }




    return (
        <>
            {
                isModalCreateHolidayVisible
                &&
                <CreateHoliday />
            }

            {
                isModalUpdateHolidayVisible
                &&
                <EditHoliday />
            }
            <HolidayFilters handleOnSearchSatusHistory={loadHolidays} />

            <div className='flex flex-col w-full'>
                <div className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 ${mobile_mode ? `flex-col` : `flex-row`} `}>
                    <span className='self-center text-white flex-1 text-center font-medium'>{displayMessage('HOLIDAYS_LIST')}</span>
                    <div className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`} >
                        <SL_Button
                            type='default'
                            className='items-center w-30 flex'
                            disabled={!haveSomethingSelected}
                            style={{ color: !haveSomethingSelected ? 'grey' : null }}
                            onClick={handleOnOpenModalDetailHoliday}
                            icon={<FileSearchOutlined className={`text-base ${haveSomethingSelected ? 'text-green-900' : ''}`} />}
                        >
                            {displayMessage('DETAIL_HOLIDAY')}
                        </SL_Button>
                    </div>
                    <div className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`} >
                        <SL_Button
                            type='default'
                            className='items-center w-30 flex'
                            onClick={handleOnOpenModalCreateHoliday}
                            icon={<PlusOutlined className={`text-base text-green-900`} />}
                        >
                            {displayMessage('CREATE_HOLIDAY')}
                        </SL_Button>
                    </div>
                </div>

                <div style={{ height: DataGridProHeight, minHeight: 300 }} >
                    <DataGridPro
                        rows={holidays}
                        apiRef={gridRef}
                        style={{ height: '100%' }}
                        columns={holiday_grid_columns.concat(actionCancel)}
                        pagination
                        pageSize={100}
                        components={{
                            Toolbar: renderCustomToolBar,
                        }}
                        onRowClick={handleRowChange}
                        density="compact"
                        disableMultipleSelection
                        onSelectionModelChange={() => handleWhatIsSelectedInGrid()}
                    />

                </div>
            </div>
        </>
    )
}